import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class StorageProvider {
	private storage: Storage | null;
	private sessionStorage: Storage | null;

	private platformId: object = inject(PLATFORM_ID);
	private storageSub = new Subject<boolean>();

	constructor() {
		this.storage = isPlatformBrowser(this.platformId) ? localStorage : null;
		this.sessionStorage = isPlatformBrowser(this.platformId) ? sessionStorage : null;
	}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	watchStorage(): Observable<any> {
		return this.storageSub.asObservable();
	}

	getItem(key: string): string | null {
		return this.storage ? localStorage.getItem(key) : null;
	}

	setItem(key: string, data: string): void {
		if (this.storage) {
			this.storage.setItem(key, data);
			this.storageSub.next(true);
		}
	}

	removeItem(key: string): void {
		if (this.storage) {
			this.storage.removeItem(key);
			this.storageSub.next(true);
		}
	}

	getSessionItem(key: string): string | null {
		return this.sessionStorage ? this.sessionStorage.getItem(key) : null;
	}

	setSessionItem(key: string, value: string): void {
		if (this.sessionStorage) {
			this.sessionStorage.setItem(key, value);
		}
	}
}
